// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bscTestnet as _bscTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bscTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 97
 * Chain Name: Binance Smart Chain Testnet
 * Default Block Explorer: https://testnet.bscscan.com
 * Default RPC URL: https://data-seed-prebsc-1-s1.bnbchain.org:8545
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bscTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bscTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bscTestnet = createCommon({
	..._bscTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
